// extracted by mini-css-extract-plugin
export var laboratory = "Laboratory-module--laboratory--30Z2d";
export var listWrapper = "Laboratory-module--listWrapper--3dMzR";